export const PipelineStatus = {
  ACTIVE: 1,
  ARCHIVED: 0
};

export const PipelineStatusOptions = [
  { value: PipelineStatus.ARCHIVED, label: 'Archived', mode: 'disabled' },
  { value: PipelineStatus.ACTIVE, label: 'Active', mode: 'success' }
];

/**
 * Stage-list API version used by the pipeline screen, the deal screen and task
 * forms.
 *
 * The unversioned / 2022-12-23 endpoint is the board summary: it runs the
 * per-column task-count and revenue aggregates and prepends the synthetic
 * Inactive/Dormant stages. Only the Board's New business figures and the
 * Performance funnel need that, and they fetch it under their own keys
 * (FLT-3371). Everything else asks for the plain stage list instead.
 *
 * Keep this in the query key. Other consumers still use the bare
 * ['pipelineStages', id] key for the summary, and in TanStack Query the first
 * observer to mount supplies the queryFn for everything on that key.
 */
export const PIPELINE_STAGES_LIST_API_VERSION = '2025-11-03';

/**
 * The plain stage list's query key. Screens share requests only when the key
 * matches exactly, the numeric id included, so build it here (FLT-3371).
 */
export const pipelineStagesListQueryKey = (
  pipelineId: number | null | undefined
) => ['pipelineStages', pipelineId, PIPELINE_STAGES_LIST_API_VERSION] as const;

/** The Performance funnel's stage summary, with per-stage deal counts. */
export const pipelineStagesFunnelQueryKey = (pipelineId: number | undefined) =>
  ['pipelineStages', pipelineId, 'funnel'] as const;
